import { type DependencyList, useEffect, useRef } from 'react';

type Timer = ReturnType<typeof setTimeout>;

export default function useDebouncedEffect(
  effect: ({ signal }: { signal: AbortSignal }) => void,
  deps: DependencyList,
  ms: number,
) {
  const timer = useRef<Timer | null>(null);
  const controller = useRef(new AbortController());

  useEffect(() => {
    timer.current = setTimeout(effect, ms, {
      signal: controller.current.signal,
    });

    // Clear the pending debounce on dep change / unmount so the effect never
    // fires (and calls setState) after the component has unmounted.
    return () => {
      if (timer.current) clearTimeout(timer.current);
    };
  }, deps);
}
